import React from 'react';
import AuthCheck from '../components/auth-check.js';
import SettingsLocationPreferences from '../components/employees/settings-location-preferences.js';
import setTitle from '../decorators/set-title.js';
import NavBarAttendant from '../components/nav/navbar-attendant.js';

export class SettingsEmployeeDeliveryPreference extends React.Component {
  render() {
    return (
      <div>
        <AuthCheck permissions={{ can_manage_all_requisitions: true }} />
        <NavBarAttendant />
        <div className="variable-width-column">
          <div className="settings-panel">
            <SettingsLocationPreferences />
          </div>
        </div>
      </div>
    );
  }
}

SettingsEmployeeDeliveryPreference = setTitle((props) => {
  return 'Delivery Settings';
})(SettingsEmployeeDeliveryPreference);

export default SettingsEmployeeDeliveryPreference;
